import { render, staticRenderFns } from "./OTPLoginForm.vue?vue&type=template&id=1312c716&"
import script from "./OTPLoginForm.vue?vue&type=script&lang=ts&"
export * from "./OTPLoginForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports